import React, { useState } from 'react';
import useComponentVisible from '@rsos/base-utils/useComponentVisible';
import { DropdownWrap } from './Dropdown.styles';

const Dropdown = ({ ...props }) => {
  const { triggerElement, triggerOnHover, triggerOnClose, children, zIndex } =
    props;
  const { ref, isComponentVisible, setIsComponentVisible } =
    useComponentVisible(false);

  // State for dropdown position
  const [dropdownPosition, setDropdownPosition] = useState({
    top: 0,
    left: 0,
    width: 0,
  });

  const handleComponentVisible = () => {
    // Only measure when opening
    if (!isComponentVisible && ref.current) {
      const rect = ref.current.getBoundingClientRect();
      setDropdownPosition({
        top: rect.bottom,
        left: rect.left,
        width: rect.width,
      });
    }
    setIsComponentVisible(!isComponentVisible);
  };

  const TriggerElement = triggerElement;
  return (
    <DropdownWrap ref={ref} zIndex={zIndex}>
      <TriggerElement
        selected={isComponentVisible}
        onClick={!triggerOnHover && handleComponentVisible}
        onMouseOver={triggerOnHover && handleComponentVisible}
      />
      {isComponentVisible
        ? typeof children === 'function'
          ? triggerOnClose
            ? children(handleComponentVisible, dropdownPosition)
            : children(dropdownPosition)
          : children
        : null}
    </DropdownWrap>
  );
};
export default Dropdown;
